import React from "react"
import { Grid, TextField, FormLabel } from "@material-ui/core"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import useConditionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useConditionEditor"

import { consolidateAIConditionMatchDefaultValidationIfNeeded, DEFAULT_AI_CONDITION_VALIDATION_INDEX } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type AIIntentionSectionEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
}

const AIIntentionSectionEditor: React.FC<AIIntentionSectionEditorProps> = (props) => {
	const {
		onSave,
		chatBotFlowBlockRule,
		children,
		hideChildSelection,
		onDelete
	} = props

	const conditionEditor = useConditionEditor({ chatBotFlowBlockRule })

	const validation = conditionEditor.getValidation(DEFAULT_AI_CONDITION_VALIDATION_INDEX)

	const handleSave = (chatBotFlowBlockRule: ChatBotFlowBlockRule) => {
		const consolidatedRule = consolidateAIConditionMatchDefaultValidationIfNeeded(chatBotFlowBlockRule)

		onSave(consolidatedRule)
	}

	return (
		<BlockBodySectionEditor
			title="INTENÇÃO"
			onSave={() => handleSave(conditionEditor.rule)}
			onOpen={conditionEditor.reset}
			onDelete={onDelete}
			hideChildSelection={hideChildSelection}
			AsideDrawerProps={{
				children: (
					<Grid
						container
						spacing={3}
					>
						<Grid
							item
							xs={12}
						>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={12}
								>
									<FormLabel>
										<b>Qual intenção deve ser identificada na mensagem?</b>
									</FormLabel>
								</Grid>
								<Grid
									item
									xs={12}
								>
									<TextField
										value={validation.extra_data?.ai_condition?.title}
										defaultValue={validation.extra_data?.ai_condition?.title}
										onChange={({ target }) => (
											conditionEditor.changeValidation(DEFAULT_AI_CONDITION_VALIDATION_INDEX, {
												extra_data: {
													ai_condition: {
														title: target.value
													}
												}
											})
										)}
										variant="outlined"
										color="primary"
										fullWidth
										placeholder="Falar com suporte"
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={12}
								>
									<FormLabel>
										<b>Como o agente deve identificar essa intenção?</b>
									</FormLabel>
								</Grid>
								<Grid
									item
									xs={12}
								>
									<TextField
										value={validation.extra_data?.ai_condition?.description}
										defaultValue={validation.extra_data?.ai_condition?.description}
										onChange={({ target }) => (
											conditionEditor.changeValidation(DEFAULT_AI_CONDITION_VALIDATION_INDEX, {
												extra_data: {
													ai_condition: {
														description: target.value
													}
												}
											})
										)}
										variant="outlined"
										color="primary"
										fullWidth
										minRows={3}
										multiline
										placeholder="Se o contato expressar intenção de falar com o suporte."
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={12}
								>
									<FormLabel>
										<b>Quais exemplos ilustram essa intenção?</b>
									</FormLabel>
								</Grid>
								<Grid
									item
									xs={12}
								>
									<TextField
										value={validation.extra_data?.ai_condition?.example}
										defaultValue={validation.extra_data?.ai_condition?.example}
										onChange={({ target }) => (
											conditionEditor.changeValidation(DEFAULT_AI_CONDITION_VALIDATION_INDEX, {
												extra_data: {
													ai_condition: {
														example: target.value
													}
												}
											})
										)}
										variant="outlined"
										color="primary"
										fullWidth
										minRows={3}
										multiline
										placeholder="‘Estou com problema no bot‘, ‘Quero falar com o suporte‘, 'Estou com problemas em uma certa funcionalidade' e expressões parecidas."
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				)
			}}
			DeletePopConfirmProps={{
				title: "Excluir intenção",
				description: "Tem certeza? Essa ação é irreversível.",
				confirmButtonText: "EXCLUIR"
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default AIIntentionSectionEditor
